
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PaymentsTable from './PaymentsTable';
import { PaymentType } from '../../../types/payment';

interface PaymentsTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  paginatedPayments: PaymentType[];
  onApprovePayment: (id: string) => void;
  onRejectPayment: (id: string) => void;
  isAdmin: boolean;
  pagination: {
    page: number;
    pageSize: number;
    totalPages: number;
  };
  onPageChange: (page: number) => void;
}

const PaymentsTabs: React.FC<PaymentsTabsProps> = ({
  activeTab,
  setActiveTab,
  paginatedPayments,
  onApprovePayment,
  onRejectPayment,
  isAdmin,
  pagination,
  onPageChange
}) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab}>
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="all">All</TabsTrigger>
        <TabsTrigger value="pending">Pending</TabsTrigger>
        <TabsTrigger value="completed">Completed</TabsTrigger>
        <TabsTrigger value="rejected">Rejected</TabsTrigger>
      </TabsList>
      
      <TabsContent value="all" className="mt-6">
        <PaymentsTable 
          payments={paginatedPayments} 
          onApprove={onApprovePayment}
          onReject={onRejectPayment}
          isAdmin={isAdmin}
          pagination={pagination}
          onPageChange={onPageChange}
        />
      </TabsContent>
      
      <TabsContent value="pending" className="mt-6">
        <PaymentsTable 
          payments={paginatedPayments} 
          onApprove={onApprovePayment}
          onReject={onRejectPayment}
          isAdmin={isAdmin}
          pagination={pagination}
          onPageChange={onPageChange}
        />
      </TabsContent>
      
      <TabsContent value="completed" className="mt-6">
        <PaymentsTable 
          payments={paginatedPayments} 
          onApprove={onApprovePayment}
          onReject={onRejectPayment}
          isAdmin={isAdmin}
          pagination={pagination}
          onPageChange={onPageChange}
        />
      </TabsContent>
      
      <TabsContent value="rejected" className="mt-6">
        <PaymentsTable 
          payments={paginatedPayments} 
          onApprove={onApprovePayment}
          onReject={onRejectPayment}
          isAdmin={isAdmin}
          pagination={pagination}
          onPageChange={onPageChange}
        />
      </TabsContent>
    </Tabs>
  );
};

export default PaymentsTabs;
